import React, { useMemo } from "react";
import { useLocation, Route, Routes, Navigate } from "react-router-dom";
import Sidebar from "components/Sidebar/Sidebar.js";
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import AdminFooter from "components/Footers/AdminFooter.js";
import PageHeader from "components/ui/PageHeader";
import branchRoutes from "BranchRoutes";
import useCurrentUser from "hooks/useCurrentUser";

const greeting = () => {
  const h = new Date().getHours();
  if (h < 12) return "Good morning";
  if (h < 18) return "Good afternoon";
  return "Good evening";
};

const BranchAdminLayout = () => {
  const mainContent = React.useRef(null);
  const location = useLocation();
  const { user } = useCurrentUser() || {};

  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    if (mainContent.current) mainContent.current.scrollTop = 0;
  }, [location]);

  const getRoutes = (rts) =>
    rts.map((p, k) =>
      p.layout === "/branch" ? <Route path={p.path} element={p.component} key={k} /> : null
    );

  const sidebarRoutes = useMemo(
    () => branchRoutes.filter((r) => r.sidebar !== false),
    []
  );

  const brandText = useMemo(() => {
    for (let r of branchRoutes) {
      if (location.pathname.includes((r.layout || "") + r.path)) return r.name;
    }
    return "Branch";
  }, [location.pathname]);

  const branchName = user?.branch?.name || "Branch";
  const userName = user?.firstName || (user?.username ? user.username.split("@")[0] : "");

  return (
    <>
      <Sidebar routes={sidebarRoutes} logo={{ innerLink: "/branch/dashboard" }} />
      <main className="pm-main" ref={mainContent}>
        <AdminNavbar brandText={brandText} profilePath="/branch/Profile" />
        <PageHeader
          role="branch"
          eyebrow={`${branchName} · Branch Admin`}
          title={userName ? `${greeting()}, ${userName}` : brandText}
          subtitle={brandText}
        />
        <div className="ph-pull">
          <Routes>
            {getRoutes(branchRoutes)}
            <Route path="*" element={<Navigate to="/branch/dashboard" replace />} />
          </Routes>
        </div>
        <AdminFooter />
      </main>
    </>
  );
};

export default BranchAdminLayout;
